<template>
  <div class="chapter">
    <van-dialog ref="dialog"
      :is-disable-close="true"
      :is-show-footer="false">
      <template slot="title">
        <van-quizzes-toolbar title="章节目录" :is-forced="false" @close="close" />
      </template>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="aside">
            <ul class="chapter-list">
              <li
                v-for="(chapter, index) in courseChapters"
                :key="index"
                @click="selectChapter(chapter)"
                :class="{ active: currentChapterId === chapter.id, 'disable': !chapter.isActive }">
                {{chapter.name}}
                <el-tag v-if="chapter.isExperience" size="mini">快速体检</el-tag>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="content">
            <div class="shadow-box">
              <div class="total">
                <div>
                  <p>
                    <template v-if="sectionInfo.isCompleted">
                      已完成本章学习
                    </template>
                    <template v-else>
                      还未完成本章学习
                    </template>
                  </p>
                  <p>
                    本章共
                    <span class="active">{{sectionInfo.sectionCount}}</span>
                    小节/
                    <span class="active">{{sectionInfo.learnCount}}</span>
                    个知识点
                  </p>
                  <p v-if="sectionInfo.isCompleted">
                    章考核
                    <span class="active">{{sectionInfo.score}}</span>
                    分
                  </p>
                </div>
                <div class="right">
                  <el-button @click="beginLearn('learning', 'learning')">顺序学习</el-button>
                  <el-button @click="beginLearn('review', 'exam')">章考试</el-button>
                  <span class="iconfont icon-list active chapter-exam-list"
                    :class="{ disable: !isOpenChapterExamList }"
                    title="更多章考"
                    @click="openCatalog(currentChapterId, 'chapter')"></span>
                </div>
              </div>
            </div>
            <div
              class="video-entry"
              @click="playVideo(currentChapter)"
              v-if="isExistsVideo">
              <i class="iconfont icon-video"></i>
              <span>&nbsp;观看章节导学</span>
            </div>
            <ul>
              <li
                v-for="(courseSection, index) in courseSections"
                :key="index"
                class="shadow-box section">
                <div class="progress-wrapper">
                  <span
                    v-if="courseSection.progress"
                    class="progress status">
                    {{courseSection.progress}}%
                  </span>
                  <span class="status" v-else>未开始</span>
                </div>
                <p>{{courseSection.name}}</p>
                <router-link
                  title="打印"
                  target="_blank"
                  :to="{
                          name: 'print-exam',
                          query: {
                            sectionId: courseSection.id,
                          },
                        }"
                  class="active iconfont icon-printer"></router-link>
                <a
                  class="iconfont icon-list"
                  title="更多练习"
                  :class="{ 'active': courseSection.isActive }"
                  @click.prevent="openCatalog(courseSection.id, 'section')"></a>
                <a
                  :class="{ 'active': courseSection.isActive }"
                  @click.prevent="beginLearn('review', 'practice', courseSection)">同步练习</a>
                <a
                  class="active"
                  @click.prevent="beginLearn('review', 'learning', courseSection)"
                  v-if="courseSection.isHasKnowledge"
                >
                  知识点识记
                </a>
                <a
                  class="active iconfont icon-video"
                  title="节导学视频"
                  v-if="courseSection.videos.length"
                  @click.prevent="playVideo({
                    id: courseSection.id,
                    name: courseSection.name,
                    isHasKnowledge: courseSection.isHasKnowledge,
                    isActive: courseSection.isActive,
                    isAvailable: courseSection.isAvailable,
                    video: courseSection.videos, action: 'section',
                    isCompleted: courseSection.progress === 100,
                  })">
                </a>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </van-dialog>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Button,
  Tag,
} from 'element-ui';
import VanDialog from '@/components/common/Dialog.vue';
import VanQuizzesToolbar from '@/components/quizzes/QuizzesToolbar.vue';
import api from '@/api/graphql/learning';
import utils from '@/services/utils';

export default {
  components: {
    ElRow: Row,
    ElCol: Col,
    ElButton: Button,
    ElTag: Tag,
    VanDialog,
    VanQuizzesToolbar,
  },
  data() {
    return {
      courseChapters: [],
      courseSections: [],
      currentChapterId: null,
      isExistsVideo: false,
      currentChapter: {},
      sectionInfo: {},
      courseId: Number(this.$route.params.courseId) || 0,
    };
  },
  computed: {
    isOpenChapterExamList() {
      return this.courseSections.every(item => item.isActive);
    },
  },
  methods: {
    open() {
      this.$refs.dialog.open();
      this.update();
    },
    close() {
      this.$refs.dialog.close();
    },
    update() {
      this.fetchCourseChapters();
    },
    playVideo(payload) {
      this.$emit('playVideo', payload);
    },
    selectChapter(chapter) {
      if (chapter && !chapter.isActive) return;

      this.fetchCourseSections(chapter ? chapter.id : this.currentChapterId)
        .then(() => {
          if (chapter) {
            this.currentChapter = chapter;
            this.currentChapterId = chapter.id;
          }
        })
        .catch((error) => {
          if (error && error.code === 1033) {
            utils.alert(`<div style="white-space: pre-line;">${error.message}</div>`, '体验结束', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '知道了',
              center: true,
            });
          } else {
            utils.error(error.message);
          }
        });
    },
    fetchCourseChapters() {
      api.getCourseChapters({
        courseId: this.courseId,
      }).then(({ courseChapters }) => {
        this.courseChapters = [
          ...courseChapters.filter(item => item.isExperience),
          ...courseChapters.filter(item => !item.isExperience),
        ];
        if (this.currentChapterId) {
          this.fetchCourseSections(this.currentChapterId);
        } else {
          const [firstChapter] = this.courseChapters.filter(course => course.isActive);
          if (firstChapter) {
            this.currentChapterId = firstChapter.id;
            this.currentChapter = firstChapter;
            this.fetchCourseSections(this.currentChapterId);
          }
        }
      });
    },
    fetchCourseSections(chapterId) {
      return api.getCourseSections({
        chapterId,
        courseId: this.courseId,
      }).then(({ courseSections }) => {
        this.currentChapter.isCompleted = courseSections.isCompleted;
        this.courseSections = courseSections.sections;
        this.isExistsVideo = courseSections.isExistsVideo;
        this.sectionInfo = courseSections;
      });
    },
    beginLearn(type, action, sectionInfo) {
      this.$emit('review', {
        action,
        type,
        chapterId: this.currentChapterId,
        chapterName: this.currentChapter.name,
        sectionId: (sectionInfo && sectionInfo.id) || 0,
      });
    },
    openCatalog(id, type) {
      this.$emit('open-catalog', {
        id,
        type,
      });
    },
  },
  created() {
    this.fetchCourseChapters();
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .chapter {
    .aside {
      box-sizing: border-box;
      width: 100%;
      height: 450px;
      border: 1px solid #eee;
      box-shadow: 0 0 2px #eee;
      padding: 10px 20px;
      overflow-y: auto;
      .chapter-list {
        height: 35px;
        line-height: 35px;
        li {
          cursor: pointer;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &.active {
            color: #50bfff;
          }
          &.disable {
            color: #999;
            cursor: no-drop;
          }
        }
      }
    }
    .shadow-box {
      border: 1px solid #eee;
      box-shadow: 0 0 2px #eee;
      padding: 15px 20px;
      border-radius: 5px;
      margin-bottom: 10px;
      color: #999;
      .progress-wrapper {
        display: inline-block;
        width: 55px;
        .status {
          display: inline-block;
          padding: 1px 2px;
          text-align: center;
          font-size: 11px;
          background-color: #eee;
        }
        .progress {
          border-radius: 2px;
          background-color: #50bfff;
          color: #fff;
        }
      }
      .active {
        color: #50bfff!important;
        cursor: pointer!important;
      }
    }
    .content {
      padding: 0 !important;
      height: 420px;
      overflow-y: auto;
      .video-entry {
        padding: 5px 0 15px 10px;;
        color: #50bfff;
        cursor: pointer;
        .icon-video {
          font-size: 20px;
        }
        span {
          position: relative;
          top: -2px;
        }
      }
      .section {
        p {
          display: inline-block;
          margin: 0;
          width: 340px;
        }
        a {
          position: absolute;
          color: #999;
          cursor: no-drop;
          &:nth-child(3) {
            right: 15px;
          }
          &:nth-child(4) {
            right: 50px;
          }
          &:nth-child(5) {
            right: 80px;
          }
          &:nth-child(6) {
            right: 150px;
          }
          &:nth-child(7) {
            right: 230px;
          }
        }
      }
      .total {
        display: flex;
        justify-content: space-between;
        .right {
          line-height: 74px;
          padding-right: 10px;
          .disable {
            color: #999!important;
            cursor: no-drop!important;
          }
          .chapter-exam-list {
            display: inline-block;
            margin-left: 10px;
            font-size: 30px;
            vertical-align: bottom;
          }
        }
      }
      .active {
        color: #50bfff;
        border-color: #50bfff;
        a {
          color: #50bfff;
        }
      }
    }
  }
</style>
